import React from 'react';
import {connect} from 'react-redux';
import {closeCentreMessage} from '../actions';

import MessageBox from '../components/MessageBox';

import './CentreMessages.css';

class CentreMessages extends React.Component {
  onClose = () => {
    const { dispatch } = this.props;
    dispatch(closeCentreMessage());
  };

  render() {
    const { message } = this.props;

    if (message) {
      const divClass = `c-centre-messages__message-box mb-type-${message.type.toLowerCase()}`;
      return (
        <div className={divClass}>
          <MessageBox heading={message.heading}
                      messages={[message.body]}
                      dangerouslySetInnerHTML={!!message.dangerouslySetInnerHTML}
                      onClose={this.onClose}/>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    message: state.view.centre_message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

CentreMessages = connect(mapStateToProps, mapDispatchToProps)(CentreMessages);

export default CentreMessages;



// WEBPACK FOOTER //
// ./src/containers/CentreMessages.js